import React, { useEffect, useState } from 'react';
import { FmlxProgressBar, FmlxModal } from 'fmlx-common-ui';
import RMModal from './RMModal';

export type ProgressStatus = 'running' | 'completed' | 'error';

export interface ProgressModalProps {
  show: boolean;
  title: string;
  message?: string;
  processed: number;
  total: number;
  status: ProgressStatus;
  errorMessage?: string;
  hideDelayMs?: number;
}

const ProgressModal = ({
  show,
  title,
  message,
  processed,
  total,
  status,
  errorMessage,
  hideDelayMs = 400,
}: ProgressModalProps) => {
  const [hideCompleted, setHideCompleted] = useState(false);

  useEffect(() => {
    if (status === 'completed') {
      setHideCompleted(false);
      const t = setTimeout(() => setHideCompleted(true), hideDelayMs);
      return () => clearTimeout(t);
    }
    setHideCompleted(false);
  }, [status, hideDelayMs]);

  const visible = show && !hideCompleted;
  const indeterminate = total <= 0;
  const value = indeterminate
    ? 0
    : Math.min(100, Math.max(0, Math.round((processed / total) * 100)));
  const isError = status === 'error';

  const titleHeading = (
    <div id="tree-control-header-selected-nodes" className="text-fmlxOrange">
      {title}
    </div>
  );

  return (
    <RMModal
      id="progress-modal"
      showModal={visible}
      setShowModal={() => {}}
      size={FmlxModal.Size.MEDIUM}
      heading={titleHeading as unknown as string}
      body={
        <div
          id="progress-modal-body"
          style={{
            padding: '1rem 0rem',
            borderTop: `2px solid #DDDDDD`,
          }}
        >
          {isError ? (
            <p
              id="progress-modal-error"
              className="m-0 mb-3"
              style={{ color: '#a40000', fontSize: '0.875rem' }}
            >
              {errorMessage}
            </p>
          ) : message ? (
            <p
              id="progress-modal-message"
              className="m-0 mb-3"
              style={{ color: '#474747', fontSize: '0.875rem' }}
            >
              {message}
            </p>
          ) : (
            <div className="mb-3" />
          )}

          {!isError && (
            <div id="progress-modal-bar-row" className="flex items-center gap-4 w-full">
              <div className="flex-1">
                <FmlxProgressBar
                  id="progress-modal-bar"
                  type={FmlxProgressBar.Type.LINEAR}
                  variant={
                    indeterminate
                      ? FmlxProgressBar.Variant.INDETERMINATE
                      : FmlxProgressBar.Variant.DETERMINATE
                  }
                  value={value}
                  size={FmlxProgressBar.Size.SMALL}
                  showLabel={false}
                />
              </div>
              {!indeterminate && (
                <span id="progress-modal-percent" className="text-sm">
                  {`${value}%`}
                </span>
              )}
            </div>
          )}
        </div>
      }
      hideFooter
      hideCloseButton
      isModalEscapeable={false}
    />
  );
};

export default ProgressModal;
